export const primaryColor = "#d4af37";
export const secondaryColor = "#000000"
export const secondaryDarkColor = "#4b4b4b"
export const colorOverBody = "white"